export default "__VITE_ASSET__6bacc71d__"